import styled from "@emotion/styled";
import colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME, BRAND_BLACK_TEXT_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";
import Colors from "styles/colors.js";
import { BRAND_SERVICE_PRIMARY_COLOR_NAME, LIGHT_BACKGROUND_PINK } from "styles/color-consts";
const SEPARATOR_LINE_COLOR = "#d9d9d9";
export const StyledProductsSwitcher = styled.div`
  max-height: calc(100vh - 80px);
  width: ${Constants.PRODUCTS_SWITCHER_SCREEN_WIDTH}px;
  border-radius: 8px;
  background-color: ${colors[WHITE_COLOR_NAME]};
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.2);
  padding: 24px;
  overflow-y: auto;

  .main-products-title-wrapper {
    margin-bottom: 16px;  

    .main-product-title {
      font-size: 0.875rem;
      color: ${colors.asphalt};
      font-weight: 400;
    }
  }

  .main-products-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    .product {

      &:nth-child(2),
      &:nth-child(3) {
        grid-column: span 1;
      }
    }
  }

  .separator-line {
    margin: 16px 0 24px 0;
    height: 0;
    border-top: 1px dotted ${SEPARATOR_LINE_COLOR};
  }

  .additional-products-title {
    font-size: 0.875rem;
    font-weight: 400;
    color: ${colors.asphalt};
    margin-bottom: 16px;
  }

  .additional-products-wrapper {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .product {
      flex: 1;
      
      .icon-wrapper {
        .picture-component {
          display: flex;
          height: 32px;
          width: 32px;
        }
      }
    }
  }

  .ai-products-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    .product {
      &:first-child {
        grid-column: span 1;
      }

      &:nth-child(2) {
        grid-column: span 1;
      }

      &:nth-child(3) {
        grid-column: span 1;
      }
    }
  }

  .product {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 400;
    color: ${colors[BRAND_BLACK_TEXT_COLOR]};
    padding: 8px;
    border-radius: 8px;
    text-decoration: none;

    .icon-wrapper {
      .picture-component {
        display: flex;
        height: 32px;
        width: 32px;
      }
    }

    .beta-tag {
      font-size: 0.6875rem;
      font-weight: 300;
      color: ${Colors[BRAND_SERVICE_PRIMARY_COLOR_NAME]};
      background-color: ${Colors[LIGHT_BACKGROUND_PINK]};
      border-radius: 2px;
      padding: 1px 5px;
      line-height: normal;
      border-radius: 32px;
    }

    .beta-tag {
      font-size: 0.5rem;
      font-weight: 400;
      color: ${colors.asphalt};
      background-color: #f0f0f0;
      padding: 3px 6px;
      border-radius: 4px;
      line-height: normal;
      white-space: nowrap;
      align-self: flex-start;
      margin-top: 2px;
    }

    &:hover {
      background-color: ${colors[BACKGROUND_GRAY_COLOR_NAME]};
    }
  }
`;
